import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    GET_DATA_LISTADO_PARAMETROS,
    GET_DATA_LISTADO_PARAMETROS_RESULT,
    RESET_STATE_LISTADO_PARAMETROS,
    FILTRAR_LISTADO_PARAMETROS,
    FILTRAR_ENTIDADES_BY_PRODUCTOS_LISTADO_PARAMETROS,
    ORDER_COLUMN_FROM_LISTADO_PARAMETROS,
    SET_ENTIDAD_ID,
    SET_FUNCTIONS_ATLAS,
    GET_ENTIDADES_NOT_SUCCESS
} from '../../Screens/ListadoParametros/actions/Actions';

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        entidades: [],
        productos: [],
        ascendente: true,
        columnaActual: "",
        filtro: "",
        productoCodigo: "Seleccione...",
        showErrorMessage: false,
        loading: false,
        functions: null,
        isFetching: false
    }
};

/**
 * Reduce store.
 */
let result;

function listadoParametros(state = initialState, action) {
    LogHelper.In(listadoParametros.name, state, action);

    switch (action.type) {

        case SET_FUNCTIONS_ATLAS:
            LogHelper.In(listadoParametros.name, state, action);

            result = {
                ...state,
                data: {
                    ...state.data,
                    functions: action.functions
                }
            };
            break;

        case GET_ENTIDADES_NOT_SUCCESS:
            LogHelper.In(listadoParametros.name, state, action);

            result = {
                ...state,
                data: {
                    ...state.data,
                    isFetching: false,
                    loading: false
                }
            };
            break;

        case GET_DATA_LISTADO_PARAMETROS:
            LogHelper.In(listadoParametros.name, state, action);

            result = {
                ...state,
                data: {
                    ...state.data,
                    isFetching: true
                }
            };
            break;

        case GET_DATA_LISTADO_PARAMETROS_RESULT:
            LogHelper.In(listadoParametros.name, state, action);

            // let entidadesOrdenadas2 = JSON.parse(JSON.stringify(action.entidades));
            //Prueba logs Automation
            let entidadesOrdenadas2
            try {
                entidadesOrdenadas2 = JSON.parse(JSON.stringify(action.entidades));
                entidadesOrdenadas2.sort(function (a, b) {
                    var textA = a.NOMBRE.toUpperCase();
                    var textB = b.NOMBRE.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
                result = {
                    ...state,
                    data: {
                        ...state.data,
                        entidades: entidadesOrdenadas2,
                        productos: action.productos,
                        loading: false,
                        isFetching: false
                    }
                };
            } catch (error) {
                console.log("Fallo ListadoParametros.js Linea 57. Data recibida: " + JSON.stringify(action.entidades));
            }
            //Fin logs automation
            break;
        case ORDER_COLUMN_FROM_LISTADO_PARAMETROS:
            LogHelper.In(listadoParametros.name, state, action);

            const entidadesOrdenadas = ordenarLista(state.data, action.columnName);

            result = {
                ...state,
                data: {
                    ...state.data,
                    columnaActual: action.columnName,
                    ascendente: entidadesOrdenadas.ascendente,
                    entidades: entidadesOrdenadas.entidades,
                    productos: state.data.productos
                }
            }

            break;
        case FILTRAR_LISTADO_PARAMETROS:
            LogHelper.In(listadoParametros.name, state, action);

            state.data.filtro = action.filtro;
            result = {
                ...state,
                data: {
                    ...state.data,
                    entidades: entidadesAMostrar(state.data, filtrarLista(state.data)),
                    productos: state.data.productos,
                    filtro: action.filtro,
                    showErrorMessage: state.data.showErrorMessage
                }
            };
            break;

        case FILTRAR_ENTIDADES_BY_PRODUCTOS_LISTADO_PARAMETROS:
            LogHelper.In(listadoParametros.name, state, action);

            state.data.productoCodigo = action.productoCodigo;
            state.data.productos.forEach(function (producto) {
                producto.seleccionado = (producto.CODIGO_PRODUCTO == action.productoCodigo);
            });

            result = {
                ...state,
                data: {
                    ...state.data,
                    entidades: entidadesAMostrar(state.data, filtrarLista(state.data)),
                    productos: state.data.productos,
                    showErrorMessage: state.data.showErrorMessage
                }
            };
            break;
        case RESET_STATE_LISTADO_PARAMETROS:
            LogHelper.In(listadoParametros.name, state, action);

            result = initialState;
            break;
        default:
            LogHelper.In(listadoParametros.name, state, action);

            result = state;
            break;
    }

    LogHelper.Out(listadoParametros.name, result);
    return result;
}

export default listadoParametros;

/**------------------------------------------------------ FUNCIONES AUXILIARES --------------------------------------------------------**/

/**
 * 
 * @param {any} data
 * @param {any} campo
 */
function ordenarLista(data, campo) {
    LogHelper.In(ordenarLista.name, data, campo);

    const ascendente = !data.ascendente;
    const entidades = data.entidades.sort(function (a, b) {
        switch (campo.toLowerCase()) {
            case "registros activos":
                if (ascendente) {
                    if (a.REGISTROS < b.REGISTROS) return 1;
                    if (a.REGISTROS > b.REGISTROS) return -1;
                } else {
                    if (a.REGISTROS > b.REGISTROS) return 1;
                    if (a.REGISTROS < b.REGISTROS) return -1;
                }
                return 0;
            case "nombre":
                if (ascendente) {
                    if (a.NOMBRE.toLowerCase() < b.NOMBRE.toLowerCase()) return 1;
                    if (a.NOMBRE.toLowerCase() > b.NOMBRE.toLowerCase()) return -1;
                } else {
                    if (a.NOMBRE.toLowerCase() > b.NOMBRE.toLowerCase()) return 1;
                    if (a.NOMBRE.toLowerCase() < b.NOMBRE.toLowerCase()) return -1;
                }
                return 0;
            case "equivalencias":
                if (ascendente) {
                    if (a.equivalencias.toLowerCase() < b.equivalencias.toLowerCase()) return 1;
                    if (a.equivalencias.toLowerCase() > b.equivalencias.toLowerCase()) return -1;
                } else {
                    if (a.equivalencias.toLowerCase() > b.equivalencias.toLowerCase()) return 1;
                    if (a.equivalencias.toLowerCase() < b.equivalencias.toLowerCase()) return -1;
                }
                return 0;
            case "productos":
                if (ascendente) {
                    if (a.productosLabel.toLowerCase() < b.productosLabel.toLowerCase()) return 1;
                    if (a.productosLabel.toLowerCase() > b.productosLabel.toLowerCase()) return -1;
                } else {
                    if (a.productosLabel.toLowerCase() > b.productosLabel.toLowerCase()) return 1;
                    if (a.productosLabel.toLowerCase() < b.productosLabel.toLowerCase()) return -1;
                }
                return 0;
        }
    });

    LogHelper.Out(ordenarLista.name, entidades, ascendente);

    return {
        entidades,
        ascendente
    };
}

/**
 * Filtra la lista de entidades por busqueda de nombre y producto.
 * @param {any} data
 */
function filtrarLista(data) {
    LogHelper.In(filtrarLista.name, data);

    let propKey = "NOMBRE";
    let entidadesFound = undefined;

    limpiarEntidades(data);

    if (data.filtro != "") {
    //normalize("NFD").replace(/[\u0300-\u036f]/g, "") : Saca los tildes
        entidadesFound = data.entidades.filter(function (u) {
            let propNombre = (u[propKey] || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");;

            return propNombre.includes(data.filtro.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });
    }
    else {
        // entidadesFound = JSON.parse(JSON.stringify(data.entidades));
        //Prueba logs Automation
        try {
            entidadesFound = JSON.parse(JSON.stringify(data.entidades));
        } catch (error) {
            console.log("Fallo ListadoParametros.js Linea 232. Data recibida: " + JSON.stringify(data.entidades));
        }
        //Fin logs Automation
    }

    LogHelper.Out(filtrarLista.name, entidadesFound);
    return entidadesFound;
}

/**
 * Indica que entidades deben mostrarse en pantalla.
 * @param {any} data
 * @param {any} entidadesFound
 */
function entidadesAMostrar(data, entidadesFound) {
    LogHelper.In(entidadesAMostrar.name, data, entidadesFound);

    let entidades = data.entidades.map(entidad => {
        entidad.mostrar = entidadesFound.some(x => x.ID == entidad.ID);
        if (entidad.mostrar && data.productoCodigo != "Seleccione...") {
            entidad.mostrar = entidad.productos.some(x => x.CODIGO_PRODUCTO == data.productoCodigo);
        }
        return entidad;
    });

    data.showErrorMessage = (entidades.filter(x => x.mostrar).length == 0)

    LogHelper.Out(entidadesAMostrar.name, entidades);
    return entidades;
}

/**
 * Limpia el campo mostrar del listado de entidades.
 * @param {any} data
 */
function limpiarEntidades(data) {
    LogHelper.In(limpiarEntidades.name, data);

    data.entidades.forEach(function (entidad) {
        entidad.mostrar = true;
    });
}